import React, { useState, useEffect, useCallback } from "react";
import api from "../../core/api";
import "./Dashboard.css";
import DashboardSkeleton from "./DashboardSkeleton";

const fa = (n) => Math.round(Number(n) || 0).toLocaleString("fa-IR");

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const load = useCallback(async (fresh = false) => {
   setLoading(true);
    setError("");
    try {
      const res = await api.get("/dashboard", {
        params: fresh ? { fresh: 1 } : undefined,
      });
      setData(res.data);
    } catch (err) {
      setError(err.response?.data?.error || "خطا در دریافت اطلاعات داشبورد");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);


const faDate = (date) => {
  const parts = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).formatToParts(date);

  const get = (t) => parts.find((p) => p.type === t)?.value || "";
  const weekday = get("weekday");
  const day = get("day");
  const month = get("month");
  const year = get("year");

  return `${weekday}، ${day} ${month} ${year}`;
};

const faTime = (date) =>
  new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

if (loading) return <DashboardSkeleton />;
  if (error && !data)
    return (
      <div className="card">
        <div className="empty">{error}</div>
        <div className="flexend">
          <button className="btn" onClick={() => load()}>
            <i className="fa-solid fa-rotate-right" /> تلاش دوباره
          </button>
        </div>
      </div>
    );


    const dateText = faDate(now);
const timeText = faTime(now);

  const net = data.balance.net;
  const balanceKind = net < 0 ? "debit" : net > 0 ? "credit" : "zero";
  const balanceLabel =
    net < 0 ? "بدهکار" : net >0 ? "بستانکار" : "تسویه";
const userName = data.user.fullName
  ? `${data.user.fullName}. خوش آمدید`
  : data.user.phoneNumber;

  return (
    <>
      <div className="ds-head">
        <div className="ds-who">
          <div className="ds-avatar">
            <i className="fa-solid fa-user" />
          </div>
          <div>
            <div className="ds-company">{data.companyName || "نام شرکت ثبت نشده"}</div>
            <div className="ds-user">{userName}</div>
          </div>
        </div>

        <div className="ds-clock">
          <div className="ds-time">{timeText}</div>
          <div className="ds-date">{dateText}</div>
        </div>
      </div>

      <div className="ds-grid">
        <Stat icon="fa-file-invoice" label="کل صورت حساب‌ها" value={fa(data.counts.total)} />
        <Stat icon="fa-money-bill" label="نقدی" value={fa(data.counts.cash)} tone="success" />
        <Stat icon="fa-clock" label="غیر نقدی" value={fa(data.counts.credit)} tone="danger" />
        <Stat icon="fa-hand-holding-dollar" label="پیش پرداخت" value={fa(data.counts.prepaid)} tone="accent" />
      </div>

      <div className="card">
        <div className="card-header-row">
          <h2>گزارش فروش (ریال)</h2>
      
        </div>
        <div className="ds-grid ds-grid-3">
          <Stat icon="fa-sun" label="فروش امروز" value={fa(data.sales.today)} />
          <Stat icon="fa-calendar-week" label="فروش این هفته" value={fa(data.sales.week)} />
          <Stat icon="fa-calendar-days" label="فروش این ماه" value={fa(data.sales.month)} />
        </div>
      </div>

      <div className="card">
        <h2>وضعیت کلی حساب مشتریان</h2>
        <div className="ds-balance">
          <div className={`ds-balance-main ${balanceKind}`}>
            <span className="ds-balance-label">بالانس کل</span>
            <b>{fa(Math.abs(net))} ریال</b>
            <span className="ds-pill">{balanceLabel}</span>
          </div>
          <div className="ds-balance-side">
            <div>
              <span className="muted">جمع بدهی مشتریان به شما: </span>
              <b>{fa(data.balance.debtors)}</b>
            </div>
            <div>
              <span className="muted">جمع طلب مشتریان از شما: </span>
              <b>{fa(data.balance.creditors)}</b>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Stat({ icon, label, value, tone = "" }) {
  return (
    <div className={`ds-stat ${tone}`}>
      <span className="ds-stat-icon">
        <i className={`fa-solid ${icon}`} />
      </span>
      <div>
        <div className="ds-stat-label">{label}</div>
        <div className="ds-stat-value">{value}</div>
      </div>
    </div>
  );
}